import React, { useEffect, useState, useRef, lazy } from 'react';
import { ImageCarousel } from '../components/ImageCarousel';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { AboutAuthorSection } from '../components/AboutAuthorSection';
import { FAQSection } from '../components/FAQSection';
import { useCurrency } from '../components/CurrencyContext';
import { LazySection } from '../components/LazySection';
import { UrgencyCountdown } from '../components/UrgencyCountdown';
import { GuaranteeDropdown } from '../components/GuaranteeDropdown';
import { AmazonReviewsSection } from '../components/AmazonReviewsSection';
import { FloatingCTA } from '../components/FloatingCTA';
import { CheckCircle2, StarIcon, XCircle, X, Check, Volume2 as Volume2Icon, VolumeX as VolumeXIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://recetariosaludable.lat/cart/42439418740821:1?checkout';
const HIGH_PAYING_JOBS = [{
  src: 'https://cdn.magicpatterns.com/uploads/64nEYja2c7QzMD13KEvpgu/Tablero1-scaled.jpg',
  title: 'Tablero de control industrial',
  pay: 'Trabajo típico: $800 – $2,000'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5bRgMHd1xeswMGD1zgrbX2/Different-Electrical-Contactor-Types.webp',
  title: 'Control de motores trifásicos',
  pay: 'Trabajo típico: $500 – $1,500'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7tUpAbMa8HcPM2CAnRDcq1/WhatsApp-Image-2024-05-03-at-13.33.57-3-1024x617.jpg',
  title: 'Lectura de diagramas reales',
  pay: 'Aquí es donde la mayoría falla'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1N8faA7vriCLi4UeLQj348/hone-use-electrical-wire.jpg',
  title: 'Instalaciones que requieren precisión',
  pay: 'Errores aquí = dinero perdido'
}];
function HighPayingJobsCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCurrent(p => (p + 1) % HIGH_PAYING_JOBS.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);
  return <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-2" data-id="element-307">
      <h3 className="text-center text-[18px] md:text-[26px] font-black text-gray-900 mb-4 leading-tight font-[Poppins,_sans-serif] uppercase" data-id="element-308">
        👉 Estos son los trabajos que pagan más (y que muchos evitan)
      </h3>
      <div className="relative overflow-hidden rounded-2xl" data-id="element-309">
        <div className="flex transition-transform duration-700 ease-in-out" style={{
        transform: `translateX(-${current * 100}%)`
      }} data-id="element-310">
          {HIGH_PAYING_JOBS.map((job, i) => <div key={i} className="flex-shrink-0 w-full px-1" data-id="element-311">
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-200 overflow-hidden" data-id="element-312">
                <div className="px-4 py-3 bg-[#FFF8E1] border-b border-[#F0EBE0] text-center" data-id="element-313">
                  <p className="text-gray-900 font-bold text-[15px] md:text-[18px] leading-tight" data-id="element-314">
                    {job.title}
                  </p>
                  <p className="text-[#22C55E] font-black text-[14px] md:text-[16px] mt-1" data-id="element-315">
                    {job.pay}
                  </p>
                </div>
                <img src={job.src} alt={job.title} className="w-full h-56 md:h-72 object-cover" loading="lazy" data-id="element-316" />
              </div>
            </div>)}
        </div>
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-2 mt-3" data-id="element-317">
        {HIGH_PAYING_JOBS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-[#F5720E] scale-125' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a slide ${i + 1}`} data-id="element-318" />)}
      </div>
    </div>;
}
export function LandingPage() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const heroVideoRef = useRef<HTMLVideoElement>(null);
  const goToCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Manual de Controles Eléctricos + Guía Práctica',
        content_type: 'product',
        value: 14.99,
        currency: 'USD'
      });
    }
    window.open(CHECKOUT_URL, '_blank');
  };
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  // Direct checkout - no cart drawer
  const toggleMute = () => {
    if (heroVideoRef.current) {
      heroVideoRef.current.muted = !heroVideoRef.current.muted;
      setIsMuted(heroVideoRef.current.muted);
    }
  };
  return <div className="min-h-screen text-gray-900 font-inter selection:bg-orange-200 bg-[#FFFF] overflow-x-clip" data-id="element-319">
      {/* ANNOUNCEMENT BAR */}
      <div className="sticky top-0 z-50 bg-[#FF8C00] h-[44px] flex items-center overflow-hidden" data-id="element-320">
        <div className="flex whitespace-nowrap animate-announcement-scroll" data-id="element-321">
          {Array.from({
          length: 6
        }).map((_, i) => <span key={i} className="font-bold text-black md:text-base tracking-wide text-[12px] mx-8 flex-shrink-0" data-id="element-322">
              🔥 SOLO POR HOY + 8 BONOS GRATIS — ACCESO COMPLETO POR SOLO $14.99
            </span>)}
        </div>
      </div>

      {/* PROBLEM & AGITATION SECTION */}
      <LazySection data-id="element-323">
        <section className="px-4 bg-white/80 pt-0 pb-0" data-id="element-324">
          <div className="max-w-2xl mx-auto space-y-[6px]" data-id="element-325">
            {/* Subheadline highlight box */}
            <div className="mx-auto max-w-md mt-1 mb-2" data-id="element-326"></div>

            {/* Hero Headline */}
            <h1 className="text-center text-gray-900 uppercase tracking-tight md:text-[40px] px-2 pt-3 font-[600] font-[Poppins,_sans-serif] text-[12px]" data-id="element-327">
              Presentando el sistema más completo de comandos eléctricos
            </h1>

            {/* Hero Subheadline */}
            <p className="text-center uppercase tracking-tight md:text-[20px] px-2 mt-1 font-[Poppins,_sans-serif] font-[600] text-[#F5720E] pt-[0px] pb-[0px] text-[28px]" data-id="element-328">
              +370 DIAGRAMAS Y SISTEMAS REALES LISTOS PARA USAR EN CAMPO
            </p>

            {/* Hero Image */}
            <div className="flex justify-center mb-2" data-id="element-329">
              <img src="https://cdn.magicpatterns.com/uploads/s8TRKizSm2pFBMg6rSkXoU/IMG_LANDER_1.png" alt="De principiante a experto en comandos eléctricos - Empieza a generar $3,000 - $6,000 al mes" className="w-full max-w-2xl rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)] pt-[20px] pb-[20px]" data-id="element-330" />
            </div>

            {/* CTA debajo de la imagen del hero */}
            <div className="flex justify-center -mt-2 mb-2 px-2" data-id="element-331"></div>

            <p className="text-center md:text-[15px] mb-3 px-2 text-[#040404] text-[16px] font-[200]" data-id="element-332">
              En 7 días ya puedes entender y ejecutar instalaciones básicas sin
              ayuda
            </p>

            {/* Este sistema es para ti si Section */}
            <div id="para-ti-section" className="mt-4 mb-4 w-full max-w-2xl mx-auto px-2 md:px-4 pt-[20px] pb-[20px]" data-id="element-333">
              <h2 className="text-center text-[22px] md:text-[32px] font-bold text-gray-900 mb-5 leading-tight font-[Poppins,_sans-serif]" data-id="element-334">
                ESTE SISTEMA ES PARA TI SI…
              </h2>

              <div className="bg-[#FFF5F5] border border-[#FEE2E2] rounded-2xl p-5 md:p-7 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-335">
                <ul className="space-y-4" data-id="element-336">
                  {['Has perdido trabajos porque no sabes cómo conectar o interpretar correctamente un sistema', 'Te enfrentas a diagramas eléctricos… pero no sabes por dónde empezar', 'Aceptas trabajos con miedo a equivocarte o hacer algo mal', 'Terminas cobrando menos porque no te sientes seguro de lo que haces', 'Has tenido que pedir ayuda… y quedar mal frente al cliente', 'Sabes que hay otros ganando más… pero no sabes qué te falta', 'Te frustra tener conocimientos básicos… pero no saber aplicarlos en la vida real'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-337">
                      <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-338" />
                      <span className="text-gray-800 font-medium text-[15px] md:text-[17px] leading-relaxed" data-id="element-339">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* REMATE - Closing punch */}
            </div>

            {/* TRABAJOS QUE PAGAN MÁS - Carousel */}
            <HighPayingJobsCarousel data-id="element-340" />

            {/* BRIDGE / CONVICTION SECTION */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4" data-id="element-341"></div>

            <div className="text-center mb-3 px-2" data-id="element-342"></div>

            {/* 👇 MIRA ESTO… heading */}
            <h3 className="text-center text-[22px] md:text-[30px] font-black text-gray-900 mt-6 mb-3 leading-tight font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-343"></h3>

            {/* Social Proof Avatars + Rating */}
            <div className="flex flex-col items-center mb-3 pt-[18px] pb-[18px]" data-id="element-344">
              {/* Overlapping Avatars */}
              <div className="flex items-center -space-x-3 mb-2" data-id="element-345">
                {['https://cdn.magicpatterns.com/uploads/aHC77Wj73vWEMuCYB1KkFm/86.jpg', 'https://cdn.magicpatterns.com/uploads/7hamwSg4b4Z5A3vEjRXdt5/11.jpg', 'https://cdn.magicpatterns.com/uploads/1daLw83rpBvzHXEtjvLwva/86_(1).jpg', 'https://cdn.magicpatterns.com/uploads/eJKoJZ6FShTQjMFiS1Ez1E/22.jpg'].map((src, i) => <img key={i} src={src} alt={`Estudiante verificado ${i + 1}`} className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover border-[3px] border-white shadow-md" loading="lazy" data-id="element-346" />)}
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 mb-1" data-id="element-347">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#4F6BFF] text-[#4F6BFF]" data-id="element-348" />)}
              </div>

              {/* Rating Text */}
              <p className="text-gray-900 font-bold text-sm md:text-base" data-id="element-349">
                4.9/5 (12,349 Estudiantes Verificados)
              </p>

              {/* Insight Card */}
              <div className="mt-2 bg-[#FFF8E1] border border-[#F0EBE0] rounded-xl px-5 py-3 max-w-md shadow-[0_2px_10px_rgba(0,0,0,0.04)] pt-[16px] pb-[16px]" data-id="element-350">
                <p className="text-gray-800 text-[14px] md:text-[15px] font-medium leading-snug text-center" data-id="element-351">
                  ⚡ Más de 12,000 electricistas ya están usando este sistema
                  para entender diagramas, hacer instalaciones reales y cobrar
                  mejor por su trabajo
                </p>
              </div>
            </div>

            {/* Identification Heading */}
            <h2 className="text-center md:text-[32px] font-bold text-gray-900 mb-4 font-[Poppins,_sans-serif] text-[20px] pt-[0px] pb-[0px]" data-id="element-352">
              Esto es exactamente lo que vas a usar para empezar a cobrar mejor
              (desde el primer día)
            </h2>

            {/* Identification Card */}
            <div id="pain-section" className="bg-[#FBF8F1] rounded-[14px] shadow-[0_2px_16px_rgba(0,0,0,0.06)] p-5 md:p-7 mb-4 border border-[#F0EBE0] text-[18px]" data-id="element-353">
              <div className="space-y-4 max-w-lg mx-auto" data-id="element-354">
                {['+370 diagramas listos para usar 👉 Trabaja con seguridad desde el primer día', 'Simulador + casos reales 👉 Practica sin cometer errores costosos', 'Domina controles eléctricos 👉 Deja de depender de otros técnicos', 'Sistema para cobrar mejor 👉 Empieza a ganar más por cada trabajo', 'Certificación profesional 👉 Más credibilidad = mejores oportunidades'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-355">
                    <CheckCircle2 className="w-5 h-5 text-[#7BAE7F] flex-shrink-0 mt-0.5" data-id="element-356" />
                    <p className="text-gray-800 md:text-[16px] text-[16px] whitespace-pre-line font-[700]" data-id="element-357">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Image Carousel - moved here, right below "Esto es exactamente lo que vas a usar" */}
            <div className="pt-2 md:pt-4 bg-white/80" data-id="element-358">
              <h2 className="md:text-4xl font-black text-gray-900 uppercase tracking-tight text-center px-4 mb-3 md:mb-4 text-[16px]" data-id="element-359">
                👉 370+ páginas a color accesibles desde cualquier dispositivo
                Celular, tablet o laptop — aprende donde quieras.
              </h2>
              <ImageCarousel data-id="element-360" />
            </div>

            {/* Video Testimonials */}
            <div id="video-testimonials-section" className="flex flex-col gap-4 mt-4 mb-4 w-full max-w-md mx-auto px-2" data-id="element-361">
              {/* Video 1 */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center pt-[15px] pb-[15px]" data-id="element-362">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-363">
                  <video src="https://cdn.magicpatterns.com/uploads/9i11Vjyfiyk1yw5VqYEhgN/undefined - Imgur (1).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="auto" data-id="element-364" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-365">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-366" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-367">
                  Luis Ramírez
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-368">
                  Técnico Electricista
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-369">
                  "Ahora puedo realizar mis propios proyectos sin depender de
                  nadie y ganar más."
                </p>
              </div>

              {/* Video 2 */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center" data-id="element-370">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-371">
                  <video src="https://cdn.magicpatterns.com/uploads/wnbQ9Bgc4WFeND59VotTcs/undefined - Imgur (2).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="auto" data-id="element-372" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-373">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-374" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-375">
                  Francisco Javier
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-376">
                  Electricista Independiente
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-377">
                  "Este material me dio la confianza para armar tableros
                  completos desde cero."
                </p>
              </div>
            </div>

            <FrustrationMethodSection data-id="element-378" />
          </div>
        </section>
      </LazySection>

      {/* HERO SECTION */}
      <LazySection data-id="element-379">
        <section className="px-4 bg-[#FFFBEB] py-1 mt-0 mb-0" data-id="element-380">
          <div className="max-w-2xl mx-auto" data-id="element-381">
            <div className="flex justify-center mt-1" data-id="element-382">
              <img src="https://cdn.magicpatterns.com/uploads/1Ma4sTrAHUAYdaEPN8LkAw/30-day-money-back-guarantee-260nw-2631258675.webp" alt="Garantía de devolución de dinero - 7, 10, 15 y 30 días" className="max-w-[200px] w-full opacity-70" loading="lazy" style={{
              mixBlendMode: 'multiply'
            }} data-id="element-383" />
            </div>
            {/* GIF */}
            <div className="flex justify-center mt-2" data-id="element-384">
              <img src="https://cdn.magicpatterns.com/uploads/vWTbJmq8bdUR5XPWmFv9yJ/FKNwrJ8.gif" alt="Reacción de satisfacción" className="w-full max-w-sm md:max-w-md rounded-2xl shadow-lg pt-[20px] pb-[20px]" loading="lazy" decoding="async" data-id="element-385" />
            </div>

            {/* Investment Reframe Box */}
            <div className="max-w-lg mx-auto mt-2 mb-4" data-id="element-386">
              <div className="bg-white border-2 border-[#F5720E]/30 rounded-2xl p-5 md:p-6 shadow-[0_4px_20px_rgba(245,114,14,0.12)] relative overflow-hidden" data-id="element-387">
                {/* Accent corner */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#F5720E] via-[#FBBF24] to-[#F5720E]" data-id="element-388"></div>

                <p className="text-gray-900 text-[16px] md:text-[18px] leading-snug mb-3 font-[Poppins,_sans-serif] font-[500]" data-id="element-389">
                  👉 Esto es lo que separa a los que cobran poco… de los que
                  ganan bien
                </p>

                <p className="text-gray-700 text-[14px] md:text-[15px] leading-relaxed mb-4" data-id="element-390">
                  Un solo trabajo bien hecho puede pagarte esto{' '}
                  <span className="font-bold text-[#F5720E]" data-id="element-391">varias veces</span>
                  .
                </p>

                <p className="text-gray-800 font-bold text-[14px] md:text-[15px] mb-2" data-id="element-392">
                  💥 La diferencia es clara:
                </p>

                <div className="space-y-2.5" data-id="element-393">
                  <div className="flex items-start gap-2.5 bg-red-50 border border-red-100 rounded-lg px-3 py-2.5" data-id="element-394">
                    <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-395" />
                    <span className="text-gray-800 text-[14px] md:text-[15px] leading-snug" data-id="element-396">
                      Seguir perdiendo dinero por no saber
                    </span>
                  </div>
                  <div className="flex items-start gap-2.5 bg-[#FFF8E1] border border-[#F7D060]/40 rounded-lg px-3 py-2.5" data-id="element-397">
                    <CheckCircle2 className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-398" />
                    <span className="text-gray-800 text-[14px] md:text-[15px] leading-snug" data-id="element-399">
                      O empezar a{' '}
                      <span className="font-bold" data-id="element-400">
                        cobrar más con seguridad
                      </span>
                    </span>
                  </div>
                </div>

                <p className="text-gray-900 text-[14px] md:text-[15px] leading-snug mt-4 font-[Poppins,_sans-serif] font-[600]" data-id="element-401">
                  👉 Hoy puedes cambiar eso.
                </p>
              </div>
            </div>
          </div>
        </section>
      </LazySection>

      {/* OFERTA PROMOCIONAL DE LANZAMIENTO */}
      <LazySection data-id="element-402">
        <section className="py-4 md:py-6 px-4 bg-white" data-id="element-403">
          <div className="max-w-4xl mx-auto" data-id="element-404">
            <div id="oferta-conviccion" className="bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)] overflow-hidden" data-id="element-405">
              {/* Urgency Bar - Full Width */}

              {/* 2-Column Layout */}
              <div className="flex flex-col md:flex-row" data-id="element-406">
                {/* LEFT: Product Image */}
                <div className="md:w-1/2 p-4 md:p-6 flex flex-col items-center justify-center bg-[#FAFAFA]" data-id="element-407">
                  <div className="relative w-full max-w-sm" data-id="element-408">
                    {/* Best Seller Sticker */}
                    <div className="absolute -top-3 -right-3 z-10 text-white text-[11px] font-black px-3 py-1.5 rounded-lg shadow-[0_3px_10px_rgba(255,107,0,0.4)] rotate-[8deg] uppercase tracking-wider border-2 border-white bg-[#F49B42]" data-id="element-409">
                      ⭐ Best Seller
                    </div>
                    <img src="https://cdn.magicpatterns.com/uploads/gpQcdGR9pb7tp62jigKpwF/8PXa8N2.png" alt="Sistema completo de Comandos Eléctricos - Todos los bonos incluidos" className="w-full rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.12)]" loading="lazy" data-id="element-410" />
                    {/* 150+ Videos Sticker */}
                    <div className="absolute -bottom-3 -right-3 z-10 bg-[#2563EB] text-white text-[11px] font-black px-3 py-1.5 rounded-lg shadow-[0_3px_10px_rgba(37,99,235,0.4)] -rotate-[6deg] uppercase tracking-wider border-2 border-white flex items-center gap-1" data-id="element-411">
                      🎬 +150 Videos
                    </div>
                  </div>
                  <div className="mt-3 text-left px-2" data-id="element-412">
                    <p className="font-bold tracking-[0.2em] uppercase mb-1 text-[12px] text-[#8E8E97]" data-id="element-413">
                      +5.478 DESCARGAS
                    </p>
                    <h3 className="text-[#111111] md:text-[28px] font-black uppercase tracking-tight text-[20px]" data-id="element-414">
                      Comandos Eléctricos PRO + Certificación Profesional ( 8
                      bonos gratis)
                    </h3>
                    <span className="inline-flex items-center gap-1 bg-[#DC2626] text-white text-[11px] font-bold px-2.5 py-1 rounded-md mt-1" data-id="element-415">
                      🎁 Oferta +50% OFF · solo 20 cupos
                    </span>

                    {/* Price Teaser Block */}
                    <div className="mt-3" data-id="element-416">
                      <p className="text-[#E53935] font-bold md:text-[24px] text-[24px]" data-id="element-417">
                        SOLO POR HOY $14.99
                      </p>
                      <p className="md:text-[14px] mt-1 opacity-70 text-[14px] text-[#0E0D0D]" data-id="element-418">
                        Antes <span className="line-through" data-id="element-419">$97</span> —
                        descuento activo hoy
                      </p>
                      <p className="text-[#999] text-[12px] mt-1" data-id="element-420">
                        💳 Pago único • Acceso inmediato
                      </p>
                    </div>
                  </div>
                </div>

                {/* RIGHT: Sales Content */}
                <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center" data-id="element-421">
                  {/* Bullets */}

                  {/* Price Block */}

                  {/* CTA Button */}
                  <button id="cta-comprar-1clic" onClick={goToCheckout} className="green-cta-impact w-full text-white font-black py-5 px-6 rounded-xl mb-4 cursor-pointer bg-[#22C55F] flex flex-col items-center gap-1" data-id="element-422">
                    <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-423">
                      SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
                    </span>
                    <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-424">
                      Acceso Inmediato • Garantía de 7 Días
                    </span>
                  </button>

                  {/* Urgency Countdown */}
                  <div className="mb-2" data-id="element-425">
                    <UrgencyCountdown data-id="element-426" />
                  </div>

                  {/* Microcopy */}
                  <p className="text-[#6b7280] text-xs text-center mb-3" data-id="element-427">
                    Acceso inmediato • Pago único • Sin suscripciones
                  </p>

                  {/* Trust Badges */}
                  <div className="flex justify-center" data-id="element-428">
                    <img src="https://cdn.magicpatterns.com/uploads/p6qxTwGmZgbzY9XkZUWTq8/Trust-badges.webp" alt="Guaranteed Safe Checkout - AES-256bit, PayPal, Stripe, McAfee Secure, Norton Secured, Visa, MasterCard, American Express, Discover" className="max-w-[240px] w-full opacity-80" loading="lazy" data-id="element-429" />
                  </div>
                </div>
              </div>

              {/* Social Proof - Full Width Bottom */}
            </div>

            {/* 7-Day Guarantee Dropdown */}
            <GuaranteeDropdown data-id="element-430" />
          </div>
        </section>
      </LazySection>

      {/* BONUSES SECTION */}
      <LazySection data-id="element-431">
        <section className="py-6 md:py-8 px-4 bg-[#0F1827]" data-id="element-432">
          <div className="max-w-4xl mx-auto" data-id="element-433">
            {/* Micro-urgency */}
            <p className="text-center text-[#FBBF24]/70 tracking-widest uppercase mb-3 text-[16px] font-[900]" data-id="element-434">
              SOLO ESTO YA PUEDE HACERTE GANAR MÁS QUE LO QUE PAGAS HOY
            </p>

            {/* Headline */}
            <h2 className="text-center text-[22px] md:text-[32px] font-black text-white mb-2 leading-tight font-[Poppins,_sans-serif]" data-id="element-435">
              COMPRA HOY Y CONSIGUE LOS BONOS GRATIS
            </h2>
            <p className="text-center text-gray-400 text-sm md:text-base mb-6 max-w-xl mx-auto" data-id="element-436">
              La mayoría falla no por falta de ganas… sino por no tener las
              herramientas correctas.
            </p>

            {/* Bonus Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-lg md:max-w-4xl mx-auto" data-id="element-437">
              {/* BONO 01 */}
              <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 flex flex-col" data-id="element-438">
                <img src="https://cdn.magicpatterns.com/uploads/aspoXaUZexU4VdVtU4U6GF/vNSeg6K.png" alt="Simulador Profesional - Lección en vídeo incluida" className="w-full max-w-[320px] mx-auto mb-3 rounded-lg" loading="eager" data-id="element-439" />
                <span className="text-[#4F6BFF] font-black text-xs tracking-widest uppercase mb-1" data-id="element-440">
                  🚀 BONO 01
                </span>
                <h3 className="text-white font-bold text-lg md:text-xl mb-2 leading-snug" data-id="element-441">
                  Simulador Profesional + Casos Reales + Clase Paso a Paso
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-1 flex-grow" data-id="element-442">
                  Practica con más de 100 escenarios reales antes de enfrentarte
                  a un trabajo de verdad.
                </p>
                <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-3" data-id="element-443">
                  Muchos recuperan la inversión solo con aplicar esto una vez.
                </p>
                <div className="space-y-1 mb-3" data-id="element-444">
                  <p className="text-gray-300 text-sm" data-id="element-445">👉 Deja de adivinar</p>
                  <p className="text-gray-300 text-sm" data-id="element-446">👉 Llega preparado</p>
                  <p className="text-gray-300 text-sm" data-id="element-447">
                    👉 Evita errores costosos
                  </p>
                </div>
                <div className="border-t border-[#2A3444] pt-3 flex items-center justify-between" data-id="element-448">
                  <span className="text-gray-500 line-through text-sm" data-id="element-449">
                    De {loading ? '...' : formatPrice(97)}
                  </span>
                  <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-450">
                    Incluido hoy sin costo adicional
                  </span>
                </div>
              </div>

              {/* BONO 02 */}
              <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 flex flex-col" data-id="element-451">
                <img src="https://cdn.magicpatterns.com/uploads/nphXyDndjQ8swuhkaKbZ1P/bsQpJfQ.png" alt="Tabla de Presupuesto - ¿Qué cantidad cobrar?" className="w-full max-w-[320px] mx-auto mb-3 rounded-lg" loading="eager" data-id="element-452" />
                <span className="text-[#FBBF24] font-black text-xs tracking-widest uppercase mb-1" data-id="element-453">
                  ⚡ BONO 02
                </span>
                <h3 className="text-white font-bold text-lg md:text-xl mb-2 leading-snug" data-id="element-454">
                  SISTEMA DE PRESUPUESTOS QUE TE HACE COBRAR BIEN
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-1 flex-grow" data-id="element-455">
                  Deja de perder dinero por no saber cuánto cobrar.
                </p>
                <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-3" data-id="element-456">
                  Esto por sí solo ya vale más que todo el acceso.
                </p>
                <div className="space-y-1 mb-3" data-id="element-457">
                  <p className="text-gray-300 text-sm" data-id="element-458">👉 Calcula rápido</p>
                  <p className="text-gray-300 text-sm" data-id="element-459">
                    👉 Cobra con seguridad
                  </p>
                  <p className="text-gray-300 text-sm" data-id="element-460">
                    👉 Deja de trabajar por menos
                  </p>
                </div>
                <div className="border-t border-[#2A3444] pt-3 flex items-center justify-between" data-id="element-461">
                  <span className="text-gray-500 line-through text-sm" data-id="element-462">
                    De {loading ? '...' : formatPrice(57)}
                  </span>
                  <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-463">
                    Incluido hoy sin costo adicional
                  </span>
                </div>
              </div>

              {/* BONO 03 */}
              <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 flex flex-col" data-id="element-464">
                <img src="https://cdn.magicpatterns.com/uploads/oP4fTp1bFbZrWb6rCaUGkS/YenQaCW.png" alt="Dimensionamiento y Cotización de Motores Eléctricos" className="w-full max-w-[320px] mx-auto mb-3 rounded-lg" loading="eager" data-id="element-465" />
                <span className="text-[#F97316] font-black text-xs tracking-widest uppercase mb-1" data-id="element-466">
                  🔧 BONO 03
                </span>
                <h3 className="text-white font-bold text-lg md:text-xl mb-2 leading-snug" data-id="element-467">
                  Calculadora Profesional para Motores
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-1 flex-grow" data-id="element-468">
                  Reduce errores y ejecuta con precisión sin depender de nadie.
                </p>
                <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-3" data-id="element-469">
                  Es lo que evita errores que cuestan dinero real.
                </p>
                <div className="space-y-1 mb-3" data-id="element-470">
                  <p className="text-gray-300 text-sm" data-id="element-471">👉 Menos errores</p>
                  <p className="text-gray-300 text-sm" data-id="element-472">👉 Más confianza</p>
                  <p className="text-gray-300 text-sm" data-id="element-473">
                    👉 Más trabajos bien hechos
                  </p>
                </div>
                <div className="border-t border-[#2A3444] pt-3 flex items-center justify-between" data-id="element-474">
                  <span className="text-gray-500 line-through text-sm" data-id="element-475">
                    De {loading ? '...' : formatPrice(47)}
                  </span>
                  <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-476">
                    Incluido hoy sin costo adicional
                  </span>
                </div>
              </div>

              {/* BONO 04 */}
              <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 flex flex-col" data-id="element-477">
                <img src="https://cdn.magicpatterns.com/uploads/cMoeunLQ4mkQin17P2Eiax/ZmXOQ4S.png" alt="Plantilla - Informe Mensual de Ingresos Brutos" className="w-full max-w-[320px] mx-auto mb-3 rounded-lg" loading="eager" data-id="element-478" />
                <span className="text-[#A78BFA] font-black text-xs tracking-widest uppercase mb-1" data-id="element-479">
                  💰 BONO 04
                </span>
                <h3 className="text-white font-bold text-lg md:text-xl mb-2 leading-snug" data-id="element-480">
                  Plantilla para Controlar tus Ingresos
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-1 flex-grow" data-id="element-481">
                  Empieza a ver cuánto estás generando realmente y deja de
                  trabajar a ciegas.
                </p>
                <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-3" data-id="element-482">
                  Aquí es donde la mayoría deja de improvisar.
                </p>
                <div className="space-y-1 mb-3" data-id="element-483">
                  <p className="text-gray-300 text-sm" data-id="element-484">👉 Control total</p>
                  <p className="text-gray-300 text-sm" data-id="element-485">
                    👉 Decisiones más inteligentes
                  </p>
                  <p className="text-gray-300 text-sm" data-id="element-486">👉 Más crecimiento</p>
                </div>
                <div className="border-t border-[#2A3444] pt-3 flex items-center justify-between" data-id="element-487">
                  <span className="text-gray-500 line-through text-sm" data-id="element-488">
                    De {loading ? '...' : formatPrice(37)}
                  </span>
                  <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-489">
                    Incluido hoy sin costo adicional
                  </span>
                </div>
              </div>
            </div>

            {/* Total Value */}
            <div className="mt-5 text-center" data-id="element-490">
              <p className="text-white md:text-3xl font-black text-[16px]" data-id="element-491">
                Valor real de estos recursos:{' '}
                <span className="text-[32px] text-[#E71111]" data-id="element-492">$238.00</span>
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-493">
                Hoy los recibes incluidos al acceder
              </p>
            </div>

            {/* Closing Block */}
            <div className="mt-6 text-center max-w-xl mx-auto" data-id="element-494">
              <p className="text-white md:text-lg font-bold mb-4 text-[14px]" data-id="element-495">
                Deja de dudar… empieza a trabajar con seguridad
              </p>

              {/* CTA */}
              <button onClick={goToCheckout} className="green-cta-impact w-full max-w-md mx-auto text-white font-black py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55E] font-[Roboto,_sans-serif] flex flex-col items-center gap-1" data-id="element-496">
                <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-497">
                  SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
                </span>
                <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-498">
                  Acceso Inmediato • Garantía de 7 Días
                </span>
              </button>
              <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-499">
                Acceso inmediato • Sin complicaciones • Todo en un solo lugar
              </p>
            </div>

            {/* BONO ESPECIAL - Certificado Profesional */}
            <div className="mt-6 bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-8 max-w-4xl mx-auto" data-id="element-500">
              <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-center" data-id="element-501">
                {/* Certificate Image */}
                <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-502">
                  <img src="https://cdn.magicpatterns.com/uploads/oWKMnxjuZgANUEU6mSNrie/img-diploma-instalador-electricista-768x543-1.png.webp" alt="Certificado Profesional Reconocido - Comandos Eléctricos" className="w-full rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.2)]" loading="eager" data-id="element-503" />
                </div>

                {/* Certificate Info */}
                <div className="w-full md:w-1/2" data-id="element-504">
                  <span className="inline-block bg-[#22C55E] text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-3" data-id="element-505">
                    BONO ESPECIAL
                  </span>
                  <h3 className="text-white text-2xl md:text-3xl font-bold leading-tight mb-3" data-id="element-506">
                    Certificado Profesional Reconocido
                  </h3>
                  <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-4" data-id="element-507">
                    Al completar la guía, recibirás un certificado digital
                    emitido por una empresa reconocida en el sector eléctrico.
                    Úsalo para demostrar tu conocimiento, destacar frente a
                    otros técnicos y generar más confianza con tus clientes.
                  </p>
                  <div className="flex items-center gap-2.5" data-id="element-508">
                    <svg className="w-5 h-5 text-[#22C55E] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-509">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-510" />
                    </svg>
                    <span className="text-white font-bold text-sm md:text-base" data-id="element-511">
                      Incluido Gratis con tu compra
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Amazon-Style Reviews Section */}
            <AmazonReviewsSection data-id="element-512" />

            {/* Instagram Testimonials Carousel */}
            <div className="mt-3 mb-4 w-full max-w-md mx-auto px-2" data-id="element-513">
              <div className="relative" data-id="element-514">
                <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-3 pb-2" data-id="element-515">
                  {['https://cdn.magicpatterns.com/uploads/7TyF6VRSGD6KvuQZUcdpKg/sDRw8GV.png', 'https://cdn.magicpatterns.com/uploads/iGuWvtqvGfLYh172NVXqdK/dZS7I5f.png', 'https://cdn.magicpatterns.com/uploads/mL9WCTdvyhgNCYL7b9wgcw/lU1G7Yi.png'].map((src, index) => <div key={index} className="flex-shrink-0 w-[85%] sm:w-[90%] snap-center" data-id="element-516">
                      <img src={src} alt={`Testimonio Instagram ${index + 1}`} className="w-full h-auto rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] border border-gray-100" loading="lazy" data-id="element-517" />
                    </div>)}
                </div>
                {/* Fade edges for scroll indication */}
                <div className="absolute top-0 bottom-2 left-0 w-4 bg-gradient-to-r from-[#0F1827] to-transparent pointer-events-none" data-id="element-518"></div>
                <div className="absolute top-0 bottom-2 right-0 w-4 bg-gradient-to-l from-[#0F1827] to-transparent pointer-events-none" data-id="element-519"></div>
              </div>
            </div>

            {/* TODO ESTO COSTARÍA POR SEPARADO */}
            <div className="mt-6 max-w-lg mx-auto" data-id="element-520"></div>

            {/* BONO EXTRA EXCLUSIVO - Acceso Vitalicio */}
            <div className="mt-6 max-w-3xl mx-auto" data-id="element-521">
              <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-5 md:p-8" data-id="element-522">
                <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-center" data-id="element-523">
                  {/* Badge Image */}
                  <div className="w-32 md:w-40 flex-shrink-0" data-id="element-524">
                    <img src="https://cdn.magicpatterns.com/uploads/mpoG7HvQk8hYGhyZmup2hr/EbrESMe.png" alt="Acceso de por vida - Toda la vida" className="w-full drop-shadow-[0_4px_20px_rgba(217,164,65,0.4)]" loading="eager" data-id="element-525" />
                  </div>

                  {/* Info */}
                  <div className="flex-1" data-id="element-526">
                    <p className="text-[#FBBF24] font-bold text-sm tracking-wider uppercase mb-1" data-id="element-527">
                      🎁 BONO EXTRA EXCLUSIVO
                    </p>
                    <h3 className="text-white text-2xl md:text-3xl font-black leading-tight mb-3" data-id="element-528">
                      Acceso Vitalicio
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-4" data-id="element-529">
                      Olvídate de las mensualidades. Con un solo pago,
                      garantizas{' '}
                      <span className="text-white font-bold" data-id="element-530">
                        acceso de por vida
                      </span>{' '}
                      a todo el material y futuras actualizaciones sin pagar un
                      centavo más.
                    </p>
                    <div className="inline-flex items-center gap-2 bg-[#22C55E]/15 border border-[#22C55E]/30 rounded-full px-4 py-2" data-id="element-531">
                      <svg className="w-4 h-4 text-[#22C55E] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-532">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-533" />
                      </svg>
                      <span className="text-[#22C55E] font-bold text-sm uppercase tracking-wider" data-id="element-534">
                        INCLUIDO GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LazySection>

      {/* GUARANTEE BADGE */}
      <LazySection data-id="element-535">
        <section className="py-6 px-4 bg-[#FFFBEB]" data-id="element-536">
          <div className="max-w-lg mx-auto" data-id="element-537">
            <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-6 md:p-8 text-center" data-id="element-538">
              {/* Badge Circle */}
              <div className="mx-auto mb-4 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-539">
                <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-540">
                  7
                </span>
                <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-541">
                  Días
                </span>
                <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-542">
                  Garantía
                </span>
              </div>

              {/* Title */}
              <h3 className="md:text-2xl font-black text-gray-900 mb-3 text-[24px] font-[Inter,_sans-serif]" data-id="element-543">
                Pruebalo durante 7 dias
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-544">
                No quiero tu dinero si este manual no transforma tu cocina. Por
                eso te doy mi{' '}
                <span className="font-bold text-gray-900" data-id="element-545">
                  Garantía Blindada de 7 Días
                </span>
                .
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3" data-id="element-546">
                Si sentís que no es para vos, nos enviás un correo y te
                devolvemos el{' '}
                <span className="font-bold text-gray-900" data-id="element-547">
                  100% de tu inversión
                </span>
                . Sin preguntas, sin vueltas.
              </p>

              {/* Closing line */}
              <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-548">
                — El riesgo es todo nuestro.
              </p>
            </div>
          </div>
        </section>
      </LazySection>

      <LazySection data-id="element-549">
        <AboutAuthorSection data-id="element-550" />
      </LazySection>

      <LazySection data-id="element-551">
        <FAQSection data-id="element-552" />
      </LazySection>

      {/* URGENCY & FINAL CLOSE */}
      <LazySection data-id="element-553">
        <div className="py-6 px-4 bg-[#0F1827] text-center" data-id="element-554">
          <div className="max-w-md mx-auto" data-id="element-555">
            <p className="text-white md:text-lg font-bold mb-3 text-[14px]" data-id="element-556">
              No dejes pasar esta oportunidad
            </p>
            <button onClick={goToCheckout} className="green-cta-impact w-full text-white py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55F] font-[900] font-[Inter,_sans-serif] flex flex-col items-center gap-1" data-id="element-557">
              <span className="text-[20px] md:text-[22px] uppercase tracking-wide" data-id="element-558">
                SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
              </span>
              <span className="text-[13px] md:text-[14px] font-semibold opacity-90" data-id="element-559">
                Acceso Inmediato • Garantía de 7 Días
              </span>
            </button>
            <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-560">
              Acceso inmediato • Sin pagos mensuales • Empiezas en segundos
            </p>
          </div>
        </div>
      </LazySection>

      {/* Floating CTA Button */}
      <FloatingCTA data-id="element-561" />

      {/* Footer */}
      <LazySection data-id="element-562">
        <footer className="bg-[#0F1827] py-5 px-4 text-center" data-id="element-563">
          <p className="text-gray-400 text-sm" data-id="element-564">
            📧 Contacto:{' '}
            <a href="mailto:apoyocomunidadelectrica@gmail.com" className="text-[#F7D060] hover:underline font-medium" data-id="element-565">
              apoyocomunidadelectrica@gmail.com
            </a>
          </p>
          <p className="text-gray-500 text-xs mt-2" data-id="element-566">
            © {new Date().getFullYear()} Comunidad Eléctrica. Todos los
            derechos reservados.
          </p>
        </footer>
      </LazySection>
    </div>;
}